import { render, staticRenderFns } from "./UserInvite.vue?vue&type=template&id=5a1658c5&"
import script from "./UserInvite.vue?vue&type=script&lang=js&"
export * from "./UserInvite.vue?vue&type=script&lang=js&"
import style0 from "./UserInvite.vue?vue&type=style&index=0&id=5a1658c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports